import { InputText } from 'primereact/inputtext';
import React from 'react';
import { twMerge } from 'tailwind-merge';
import { ReactComponent as ClearIcon } from '../../../assets/icons/svg/shared/ic-shared-clear.svg';

interface SelectMenuSearchInputProps {
  id: string;
  value: string;
  onValueChange: (value: string) => void;
  placeholder?: string;
  PrefixIcon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
}

export const SelectMenuSearchInput = ({
  id,
  value,
  onValueChange,
  placeholder,
  PrefixIcon,
}: SelectMenuSearchInputProps) => {
  const handleClear = () => onValueChange('');

  return (
    <div className='px-[12px] flex items-center relative'>
      {PrefixIcon && <PrefixIcon className='absolute top-1/2 -translate-y-1/2 left-[28px]' />}

      <InputText
        id={`${id}-drawer-text-input`}
        className={twMerge(
          'w-full font-metricR text-[14px] bg-bw02 border border-bw04 rounded-lg outline-none shadow-none px-[14px] py-[10px] h-[40px]',
          PrefixIcon ? '!pl-9' : '',
        )}
        placeholder={placeholder}
        value={value}
        onChange={(event) => onValueChange(event.target.value)}
      />

      {value && (
        <button
          id='ClearInput'
          className='w-fit hidden absolute top-1/2 z-10 -translate-y-1/2 right-[14px]'
          type='button'
          onClick={handleClear}
        >
          <ClearIcon />
        </button>
      )}
    </div>
  );
};
